import { createContext, useContext, useState, useCallback } from 'react';
import { getGroupsInCompany } from 'api/group-setting';
import { getUserListingInCompany } from 'api/user-api';
import toast from 'react-hot-toast';

const CompanyDataContext = createContext();

export const CompanyDataProvider = ({ children }) => {
  const [groups, setGroups] = useState([]);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState({ groups: false, members: false });

  // Fetch Groups
  const fetchGroups = useCallback(async () => {
    setLoading((prev) => ({ ...prev, groups: true }));
    try {
      const groupInCompanyRes = await getGroupsInCompany();
      const groupsList = groupInCompanyRes?.data?.groups || [];
      setGroups(groupsList);
      return groupsList;
    } catch (error) {
      toast.error('Failed to fetch groups');
      return [];
    } finally {
      setLoading((prev) => ({ ...prev, groups: false }));
    }
  }, []);

  const fetchMembers = useCallback(async () => {
    setLoading((prev) => ({ ...prev, members: true }));
    try {
      const UserListingRes = await getUserListingInCompany();
      const usersList =
        UserListingRes?.data?.users?.map((user) => ({
          ...user,
          label: user?.name || user?.email || user?.uuid
        })) || [];
      setMembers(usersList);
      return usersList;
    } catch (error) {
      toast.error('Failed to fetch company members');
      return [];
    } finally {
      setLoading((prev) => ({ ...prev, members: false }));
    }
  }, []);

  return (
    <CompanyDataContext.Provider value={{ groups, members, fetchGroups, fetchMembers, loading }}>
      {children}
    </CompanyDataContext.Provider>
  );
};

export const useCompanyDetailsContext = () => useContext(CompanyDataContext);
